import { render, staticRenderFns } from "./ExclusiveGatewayProps.vue?vue&type=template&id=b5580198"
import script from "./ExclusiveGatewayProps.vue?vue&type=script&lang=js"
export * from "./ExclusiveGatewayProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports